module.exports = __webpack_public_path__ + "img/Download_2.92bdd785.svg";